<template>
  <landing-page label="factSheet.obesity" labelColor="#603813" descColor="#603813" :eggImgObj="{ componentName: 'factsheet', imgName: 'obesityLandingImage', imgFormat: 'png' }" :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightBrownRight', imgFormat: 'svg' }" />

  <div id="infoGroup" style="width: 60vw" class="fact-sheet-subpages pt-16 text-2xl font-jost space-y-12 m-auto pb-24">
    <div>
      <div v-html="t('factSheet.obesityDesc')" class="space-y-5" />
    </div>

    <div>
      <div v-html="t('factSheet.whatIsObesity')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.BMI") }}</div>
      <div v-html="t('factSheet.BMIDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.idealWeightRangeTable") }}</div>
      <table class="table-auto mt-5 w-full border border-black">
        <thead>
          <tr>
            <th class="w-1/2 border border-black">{{ t("factSheet.height") }}</th>
            <th>{{ t("factSheet.idealWeightRange") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in factSheetStore.ideaBodyWeightList" :key="'ideaBodyWeight' + index" class="text-center">
            <td class="border border-black px-8 py-5">
              {{ t(item.height) }}
            </td>
            <td class="border border-black px-8 py-5">
              {{ t(item.idealWeightRange) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div>
      <table class="w-full">
        <thead>
          <tr>
            <th class="border border-black px-8 py-5 w-1/2">
              {{ t("factSheet.obesity") }}
            </th>
            <th class="border border-black px-8 py-5">
              {{ t("factSheet.bmi25") }}
            </th>
          </tr>
          <tr>
            <th class="border border-black px-8 py-5">
              {{ t("factSheet.overweight") }}
            </th>
            <th class="border border-black px-8 py-5">
              {{ t("factSheet.bmi23") }}
            </th>
          </tr>
          <tr>
            <th class="border border-black px-8 py-5">
              {{ t("factSheet.standard") }}
            </th>
            <th class="border border-black px-8 py-5">
              {{ t("factSheet.bmi185") }}
            </th>
          </tr>
          <tr>
            <th class="border border-black px-8 py-5">
              {{ t("factSheet.underweight") }}
            </th>
            <th class="border border-black px-8 py-5">
              {{ t("factSheet.bmiBelow185") }}
            </th>
          </tr>
        </thead>
      </table>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.centralObesity") }}</div>
      <div v-html="t('factSheet.centralObesityDesc')" class="space-y-5" />
    </div>

    <div>
      <table class="w-full">
        <thead>
          <th class="border border-black w-1/3">{{ t("factSheet.gender") }}</th>
          <th class="border border-black w-1/3">{{ t("factSheet.waistCircumferenceCm") }}</th>
          <th class="border border-black w-1/3">{{ t("factSheet.waistCircumferenceInch") }}</th>
        </thead>
        <tbody class="text-center">
          <tr>
            <td class="border border-black px-8 py-5">
              {{ t("factSheet.male") }}
            </td>
            <td class="border border-black px-8 py-5">
              {{ t("factSheet.90OrAbove") }}
            </td>
            <td class="border border-black px-8 py-5">
              {{ t("factSheet.around36") }}
            </td>
          </tr>
          <tr>
            <td class="border border-black px-8 py-5">
              {{ t("factSheet.female") }}
            </td>
            <td class="border border-black px-8 py-5">
              {{ t("factSheet.80OrAbove") }}
            </td>
            <td class="border border-black px-8 py-5">
              {{ t("factSheet.around32") }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.obesityAndDisease") }}</div>
      <div v-html="t('factSheet.obesityAndDiseaseDesc')" class="space-y-5" />
    </div>

    <div>
      <ul class="bullet-big">
        <template v-for="(item, index) in factSheetStore.obesityDiseaseList" :key="'obesityDisease' + index">
          <li v-html="t(item.label)" />
        </template>
      </ul>
    </div>

    <div class="font-bold text-description">{{ t("factSheet.tipsIdealWeight") }}</div>

    <div>
      <ol>
        <template v-for="(item, index) in factSheetStore.obesityIdealWeightList" :key="'obesityIdealWeight' + index">
          <li class="mt-12 font-bold">{{ t(item.label) }}</li>
          <div class="text-description" v-if="item.desc">{{ t(item.desc) }}</div>
          <ul class="bullet-big space-y-12">
            <template v-for="(listItem, idx) in item.list" :key="'hepatitisAImprovedSanitationItem' + index + idx">
              <li v-html="t(listItem)" />
            </template>
          </ul>
        </template>
      </ol>
    </div>

    <div v-html="t('factSheet.obesityRef')" class="mt-5" />

    <!-- Chinese Version -->
    <section class="!font-sanstc space-y-12">
      <div>
        <div class="font-bold text-description text-center text-4xl">{{ t("factSheetChinese.obesityTitle") }}</div>
      </div>

      <div>
        <div v-html="t('factSheetChinese.obesityDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.BMI") }}</div>
        <div v-html="t('factSheetChinese.BMIDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.idealWeightRangeTable") }}</div>
        <table class="table-auto mt-5 w-full border border-black">
          <thead>
            <tr>
              <th class="w-1/2 border border-black">{{ t("factSheetChinese.height") }}</th>
              <th>{{ t("factSheetChinese.idealWeightRange") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in factSheetStore.ideaBodyWeightList" :key="'ideaBodyWeight' + index" class="text-center">
              <td class="border border-black px-8 py-5">
                {{ t(item.height) }}
              </td>
              <td class="border border-black px-8 py-5">
                {{ t(item.idealWeightRange) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <table class="w-full">
          <thead>
            <tr>
              <th class="border border-black px-8 py-5 w-1/2">
                {{ t("factSheetChinese.obesity") }}
              </th>
              <th class="border border-black px-8 py-5">
                {{ t("factSheetChinese.bmi25") }}
              </th>
            </tr>
            <tr>
              <th class="border border-black px-8 py-5">
                {{ t("factSheetChinese.overweight") }}
              </th>
              <th class="border border-black px-8 py-5">
                {{ t("factSheetChinese.bmi23") }}
              </th>
            </tr>
            <tr>
              <th class="border border-black px-8 py-5">
                {{ t("factSheetChinese.standard") }}
              </th>
              <th class="border border-black px-8 py-5">
                {{ t("factSheetChinese.bmi185") }}
              </th>
            </tr>
            <tr>
              <th class="border border-black px-8 py-5">
                {{ t("factSheetChinese.underweight") }}
              </th>
              <th class="border border-black px-8 py-5">
                {{ t("factSheetChinese.bmiBelow185") }}
              </th>
            </tr>
          </thead>
        </table>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.centralObesity") }}</div>
        <div v-html="t('factSheetChinese.centralObesityDesc')" class="space-y-5" />
      </div>

      <div>
        <table class="w-full">
          <thead>
            <th class="border border-black w-1/3">{{ t("factSheetChinese.gender") }}</th>
            <th class="border border-black w-1/3">{{ t("factSheetChinese.waistCircumferenceCm") }}</th>
            <th class="border border-black w-1/3">{{ t("factSheetChinese.waistCircumferenceInch") }}</th>
          </thead>
          <tbody class="text-center">
            <tr>
              <td class="border border-black px-8 py-5">
                {{ t("factSheetChinese.male") }}
              </td>
              <td class="border border-black px-8 py-5">
                {{ t("factSheetChinese.90OrAbove") }}
              </td>
              <td class="border border-black px-8 py-5">
                {{ t("factSheetChinese.around36") }}
              </td>
            </tr>
            <tr>
              <td class="border border-black px-8 py-5">
                {{ t("factSheetChinese.female") }}
              </td>
              <td class="border border-black px-8 py-5">
                {{ t("factSheetChinese.80OrAbove") }}
              </td>
              <td class="border border-black px-8 py-5">
                {{ t("factSheetChinese.around32") }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.obesityAndDisease") }}</div>
        <div v-html="t('factSheetChinese.obesityAndDiseaseDesc')" class="space-y-5" />
      </div>

      <div>
        <ul class="bullet-big">
          <template v-for="(item, index) in factSheetStore.obesityDiseaseList" :key="'obesityDisease' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ul>
      </div>

      <div class="font-bold text-description">{{ t("factSheetChinese.tipsIdealWeight") }}</div>

      <div>
        <ol>
          <template v-for="(item, index) in factSheetStore.obesityIdealWeightList" :key="'obesityIdealWeight' + index">
            <li class="mt-12 font-bold">{{ t(item.label.replace("factSheet", "factSheetChinese")) }}</li>
            <div class="text-description" v-if="item.desc">{{ t(item.desc.replace("factSheet", "factSheetChinese")) }}</div>
            <ul class="bullet-big space-y-12">
              <template v-for="(listItem, idx) in item.list" :key="'hepatitisAImprovedSanitationItem' + index + idx">
                <li v-html="t(listItem.replace('factSheet', 'factSheetChinese'))" />
              </template>
            </ul>
          </template>
        </ol>
      </div>

      <div v-html="t('factSheetChinese.obesityRef')" class="mt-5" />
    </section>
  </div>
</template>

<script setup lang="ts">
import { useFactSheetStore } from "@/stores/factSheet";
import { useHeaderStore } from "@/stores/header";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const factSheetStore = useFactSheetStore();
const headerStore = useHeaderStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {
  headerStore.routerName = 'factsheet';
});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>